import {getCurrentISOOffset} from "@/shared/utils/datefunctions";
import {api} from "@/shared/api";
import * as Button from "@/shared/utils/button";

declare let TRANSACTION_ID: string;


export class PaymentErrorPage {

	private static PAYMENT_URL = "/timr/pricing/customize.html";
	private performingPayment = false;

	private readonly paymentErrorBtn: JQuery;

	constructor() {
		this.paymentErrorBtn = $("#paymentErrorBtn");
		this.paymentErrorBtn.click(() => {
			Button.setLoading(this.paymentErrorBtn);
			this.retryPayment();
		});
		this.paymentErrorBtn.text(TRANSACTION_ID?.length ? messages["dialog.payment.retry"] : messages["dialog.payment.restart"]);
	}

	/**
	 * Retry the payment if there is no actual {@code performingPayment} and an available {@code TRANSACTION_ID}
	 * If the request failed, link to the beginning of the payment process to start the payment again
	 * @private
	 */
	private retryPayment() {
		if (!this.performingPayment) {
			if (TRANSACTION_ID?.length) {
				this.performingPayment = true;
				void api("account/payment/retryPayment.json")
					.post({
						transactionId: TRANSACTION_ID,
						timeZone: getCurrentISOOffset()
					})
					.then((response: { redirectLocation: string }) => {
						window.location.href = response.redirectLocation;
					})
					.fail(() => {
						this.paymentErrorBtn
							.removeClass("disabled")
							.text(messages["dialog.payment.restart"])
							.click(e => {
								e.preventDefault();
								window.location.href = PaymentErrorPage.PAYMENT_URL;
							});
					})
					.always(() => this.performingPayment = false);
			} else {
				window.location.href = PaymentErrorPage.PAYMENT_URL;
			}
		}
	}
}
